// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2f760","info":"UpdateTermsInfo_info__S5gWV"};